import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_31: FaireProductEntity = {
  token: "starter_collection_31",
  type: "product",
  name: "The Trio of Knives",
  brandName: "Material",
  imageUrl: "",
  priceDollars: 145,
  msrpDollars: 290,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
